import type { ReactNode } from 'react'
import { useId } from 'react'
import { Trash02Icon } from '@systemeio/icons'
import { cn } from 'cn'
import { useTranslation } from 'next-i18next/pages'
import { usePostAttachmentsContext } from '../context'

interface RemoveAttachmentButtonProps {
  id: number | string
  className?: string
}

export default function RemoveAttachmentButton(props: RemoveAttachmentButtonProps): ReactNode {
  const id = useId()
  const { t } = useTranslation()
  const { removeAttachment } = usePostAttachmentsContext()

  return (
    <button
      data-testid="attachment-remove"
      className={cn('rounded-full bg-button-destructive-default p-1', props.className)}
      onClick={e => {
        e.stopPropagation()
        removeAttachment(props.id)
      }}
      aria-labelledby={id}
      type="button"
    >
      <span id={id} hidden>
        {t('global.remove')}
      </span>
      <Trash02Icon className="size-5 text-icon-on" fill="CurrentColor" />
    </button>
  )
}
